<template>

</template>

<script>
  export default {
    beforeCreate() {
      const { $store, $router } = this;
      if ($store.state.loggedIn) {
        $router.replace({
          path: '/admin/campaigns',
        });
      } else {
        $router.replace({
          path: '/login',
        });
      }
    },
  };
</script>



// WEBPACK FOOTER //
// Splash.vue?40dce2e0